<template lang="pug">
#PageTargetDetailHome
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Target Information" :HeaderGlobalBreadcrumb="breadcrumb")

    section.section-content.section-content--data-usage
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading General Information
                    .header-cta
                        router-link.btn.btn-primary(:to="'/target/'+single_target_detail.id+'/edit'") Edit Target
            .box__body.p-4(v-if="load_data_status_single_target_detail !== 'loading'")
                .flex.flex-wrap.-mx-4   
                    .block.px-4.mb-4(
                        class="w-full lg:w-1/3 lg:mb-0"
                        )
                        .block.mb-4
                            span.block.mb-2.text-light Target Name
                            h3.font-normal {{ single_target_detail.target_name }}
                    .block.px-4.mb-4(
                        class="w-full lg:w-2/3 lg:mb-0"
                        )
                        .block.mb-4
                            span.block.mb-2.text-light Operation Name
                            h3.font-normal {{ toString(single_target_detail.cases) }}
                    .block.px-4.w-full
                        .block.mb-4.pt-4.border-t.border-dashed
                            span.block.mb-2.text-light Description
                            h3.font-normal {{ single_target_detail.description?single_target_detail.description:'-' }}
            .box__body.p-4(v-else)
                Loading(show="true")
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Notes
                    .header-cta
                        //- router-link.btn.btn-primary(:to="'/target/'+single_target_detail.id+'/edit'") Edit Target
            .box__body.p-4
                .pb-2
                    strong.block.text-xs.uppercase.text-light.mb-4 New Note
                    div.flex.mb-2
                        .field.flex-grow
                            textarea.field-style(
                                v-model="tmpNote"
                                placeholder="Add new note..."
                                style="min-height: 50px;"
                            )
                            //- v-on:keydown.enter.exact.prevent
                            //- v-on:keydown.enter.shift.exact.prevent
                            //- v-on:keyup.enter.exact="addNote"
                    div.mb-2
                        .flex.items-center.justify-end
                            template(v-if="tmpNote && tmpNote.length>0")
                                button.btn-primary(@click="addNote") Save
                            template(v-else)
                                button.btn.btn-primary.btn-primary--disabled(disabled="disabled" style="pointer-events:none") Save

                .block
                    strong.block.text-xs.uppercase.mb-4.text-light History notes
                    template(v-if="load_data_status_note_target_list == 'loading'")
                        .flex.flex-wrap.items-center.justify-center
                            Spinner(show="true" size="48")

                    .list.mb-3.pb-3.border-b(v-else-if="dataNotes && dataNotes.length > 0" v-for="note in dataNotes")
                        p.mb-1 {{note.notes}}
                        small.text-right.opacity-75 {{note.created_at?datetimeFormat(note.created_at, 'DD MMMM YYYY HH:mm:ss [WIB]'):'-'}} • added by {{note.created_by?note.created_by:'-'}}

                    .flex.flex-wrap.items-center.justify-center(v-else)
                        strong.block.text-xs.uppercase.mb-4 No History Available
                .block                            
                    template(v-if="load_data_status_note_target_list != 'loading' && (dataNotes && dataNotes.length > 0)")
                        small(v-if="!isLoadingNext") {{dataNotes.length}} of {{totalNotes}} items
                        .flex.flex-wrap.items-center.justify-center
                            template(v-if="isLoadingNext")
                                Spinner(show="true" size="48")
                            template(v-else)
                                template(v-if="pageNotes<totalPageNotes")
                                    button.btn-small.btn-primary(@click="handleNextNotes") Load More                            
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Lists Clues
                    .header-cta
                        router-link.btn.btn-primary(:to="'/target/'+single_target_detail.id+'/edit'") Edit Target
            .box__body.p-4(v-if="load_data_status_single_target_detail !== 'loading'")
                .flex.flex-wrap.-mx-4
                    template(v-for="clue in single_target_detail.clues")    
                        .block.px-4(class="w-1/3")
                            .block.mb-4
                                span.text-light {{ clue.name.toUpperCase() }}
                                    h3.link-text {{ clue.value }}
                                        //- router-link(to="/target/detail/recent-location") {{ clue.value }}
                        .block.px-4(class="w-1/3" v-if="clue.detail && clue.detail.length > 0" v-for="detail in clue.detail")
                            .block.mb-4
                                span.text-light {{ detail.name.toUpperCase() }}
                                    h3.link-text {{ detail.value? detail.value : '-' }}
            .box__body.p-4(v-if="load_data_status_single_target_detail !== 'loading'")
                .flex.flex-wrap.-mx-4 
                    .block.px-4(class="w-1/3")
                        .block.mb-4
                            h3.text-light {{ 'IMEI History' }}
                                // h3.link-text {{ histImei.imei? histImei.imei : '-' }}
                    .block.px-4(class="w-1/3")
                    .block.px-4(class="w-1/3")
                    // template(v-for="histImei in single_target_detail.history_imei")        
                .flex.flex-wrap.-mx-4(v-if="single_target_detail && single_target_detail.history_imei && single_target_detail.history_imei.length>0")
                    template(v-if="ind-1 < single_target_detail.history_imei.length" v-for="ind in historyImeiShow")    
                        .block.px-4(class="w-1/3")
                            .block.mb-4
                                span.text-light {{ 'IMEI' }}
                                    h3.link-text {{ single_target_detail.history_imei[ind-1].imei? single_target_detail.history_imei[ind-1].imei : '-' }}
                        .block.px-4(class="w-1/3")
                            .block.mb-4
                                span.text-light {{ 'Last Updated' }}
                                    h3.link-text {{ single_target_detail.history_imei[ind-1].created_at? single_target_detail.history_imei[ind-1].created_at : '-' }}
                        .block.px-4(class="w-1/3")

                .flex.flex-wrap.items-center.justify-center(v-else)
                    strong.block.text-xs.uppercase.mb-4 No History IMEI Available
                    
                .flex.flex-wrap.items-center.justify-center.-mx-4(v-if="checkButtonMoreImei() || checkButtonLessImei()")
                    .block.px-4
                        button(v-if="checkButtonMoreImei()" @click="incrButtonMoreImei(historyImeiIncr)") Show More
                    .block.px-4(v-if="checkButtonLessImei() && checkButtonMoreImei()") |
                    .block.px-4(v-if="checkButtonLessImei()")
                        button(@click="decrButtonLessImei(null, historyImeiIncr)") Show Less
                        
            .box__body.p-4(v-else)
                Loading(show="true")

            // .box__body.p-4(v-if="checkButtonMoreImei()")
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Lists Additional Information
                    .header-cta
                        router-link.btn.btn-primary(:to="'/target/'+single_target_detail.id+'/edit'") Edit Target
            .box__body.p-4(v-if="load_data_status_single_target_detail !== 'loading'")
                .flex.flex-wrap.-mx-4(v-if="single_target_detail.additional_info && single_target_detail.additional_info.length > 0")
                    .block.px-4(class="w-1/3" v-for="info in single_target_detail.additional_info")
                        .block.mb-4
                            span.text-light  {{ info.name }}
                            h3.font-normal.text-gray-800 {{ info.value }}
                .flex.flex-wrap.items-center.justify-center(v-else)
                        strong.block.text-xs.uppercase.text-gray-600.m-4 No Data Available
            .box__body.p-4(v-else)
                Loading(show="true")
        .box
            .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Detail
            .box__body
                .box-tabs
                    vue-tabs(
                        v-model="tabName"
                        @tab-change="handleTabChange"
                        ref="tabsRef"
                    )
                        v-tab(title="Monitoring History")
                            MonitoringHistory

                        v-tab(title="Location History")
                            LocationHistory

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue';
import {VueTabs, VTab} from 'vue-nav-tabs';
import MonitoringHistory from './MonitoringHistory.vue';
import LocationHistory from './LocationHistory.vue';
import Spinner from '@/components/Spinner.vue';
import moment from 'moment';
import Loading from '@/components/Loading.vue';

export default {
    name: 'PageTargetDetailHome',
    components: {
        HeaderGlobal,
        VueTabs,
        VTab,
        MonitoringHistory,
        LocationHistory,
        Spinner,
        Loading,
    },
    props: ['resultGlobalBreadcrumb'],
    data: function() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Detail Target Home',
                    url: '/target/detail/home',
                },
            ],
            openNote: false,

            tmpTargetId: null,
            tmpNote: null,

            dataNotes: [],
            pageNotes: 0,
            totalPageNotes: 1,
            limitNotes: 10,
            totalNotes: 0,
            
            isLoadingNext: false,

            tabName: '',


            historyImeiShow: parseInt(process.env.VUE_APP_HISTORY_IMEI_LIMIT) || parseInt(10),
            historyImeiIncr: parseInt(process.env.VUE_APP_HISTORY_IMEI_LIMIT) || parseInt(10),
        };
    },
    computed: {
        ...mapState([
            'single_target_detail',
            'load_data_status_single_target_detail',
            'load_data_status_note_target_list',
            'note_target_list',

            // for open new tab
            'load_data_status_recent_location_es_list',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
    },
    methods: {
        // getData() {
        //     // this.showLoading(true);
        //     this.$store.commit('setTargetRedirect', 'detail');        
        //     this.$store.dispatch('getSingleTargetDetail', [this.id])
        //     .then((resp) => {
        //         if (resp === 'success') {
        //             // this.showLoading(false);

        //         } else {
        //             this.error();
        //         }
        //     });
        //     this.getNotes(true, this.id)
        // },

        changeDefaultTab(index=null){
            var self = this;
            self.$nextTick(() => {
                // if (self.tabActive != null && typeof(self.$refs.tabsRef) !== 'undefined') {
                //     self.$refs.tabsRef.navigateToTab(self.tabActive);
                //     this.setTabActive(null);
                // } else if(index != null){
                //     self.$refs.tabsRef.navigateToTab(index);
                // }
                if(index != null)
                    self.$refs.tabsRef.navigateToTab(index);
            });
        },
        incrButtonMoreImei(incr=1) {
            this.historyImeiShow = parseInt(this.historyImeiShow)
            this.historyImeiShow += parseInt(incr)
        },
        decrButtonLessImei(decr=null, value=null) {
            this.historyImeiShow = parseInt(this.historyImeiShow)
            if (decr)
                this.historyImeiShow -= parseInt(decr)
            else if (value)
                this.historyImeiShow = parseInt(value)
        },
        checkButtonMoreImei() {
            if (!this.single_target_detail) return false; 
            if (!this.single_target_detail.history_imei) return false;
            if (this.single_target_detail.history_imei.length==0) return false;

            let returnData = this.historyImeiShow < this.single_target_detail.history_imei.length
            
            return returnData
        },
        checkButtonLessImei() {
            let returnData = this.historyImeiShow > this.historyImeiIncr
            
            return returnData
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        toString(array) {
            if (array && array.length > 0) {            
                return Object.keys(array).map(function(k){
                    return array[k].operation_name
                }).join(", ")
            } else {
                return '-'
            }
        },
        toggleSidebar(){
            EventEmit.$emit('toggleSidebar')
        },
        getNotes(open=true, target_id=null) {
            this.$store.commit('setNoteTargetList', {});
            if(open){
                this.tmpTargetId = target_id
                this.$store.dispatch('getNoteTargetList', [true, this.tmpTargetId, this.limitNotes, this.pageNotes+1]);
                this.openNote = true
            } else {
                this.setEmptyNotes()
            }
        },
        handleNextNotes() {
            this.isLoadingNext=true
            this.$store.dispatch('getNoteTargetList', [false, this.tmpTargetId, this.limitNotes, this.pageNotes+1]);
        },
        addNote(){
            this.showLoading(true);
            this.$store.dispatch('getNoteTargetCreate', [this.tmpTargetId, this.tmpNote])
                .then((resp) => {
                    if (resp === 'success') {
                        // this.getNotes(false)
                        this.tmpNote = null
                        this.setDefaulDataNotes()

                        this.getNotes(true, this.tmpTargetId);

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Note successfully added!',
                            timer: 3000,
                        });
                    } else {
                        if (resp.data.message) {
                            this.error(resp.data.message);
                        } else {
                            this.error();
                        }
                    }
                });
        },
        setEmptyNotes(){
            this.tmpTargetId = null
            this.tmpNote = null
            this.openNote = false
        },
        setDefaulDataNotes(){
            // console.log('masuk set null')
            this.dataNotes = [];
            this.totalNotes = 0;
            this.limitNotes = 10;
            this.pageNotes=0;
            this.totalPageNotes=1;
        },
        datetimeFormat(datetime, format="DD MMM YYYY hh:mm:ss") {
            return moment(datetime, 'YYYY-MM-DDThh:mm:ssZ').format(format);
        },
        handleTabChange(tabIndex, newTab){
            // console.log('startMapLocationHistory', [tabIndex, newTab])
            if(newTab.title.toLowerCase() == 'location history' && this.load_data_status_recent_location_es_list !== 'loading')
                EventEmit.$emit('startMapLocationHistory');
        },
    },
    mounted() {
        // this.getData();
        this.tabName = 'Monitoring History';
        this.changeDefaultTab(0);
    },
    watch: {
        route_name(newData) {
            if (newData === 'PageTargetDetailHome') {
                this.tabName = 'Monitoring History';
                // this.getData();
                this.changeDefaultTab(0);
            }
        },
        single_target_detail(newData){
            // console.log('single_target_detail')
            // console.log(newData)
            if (newData && Object.keys(newData).length > 0) {
                this.getNotes(true, newData.id)
            }
        },
        // historyImeiShow(newData){
        //     console.log({newData})
        // },
        note_target_list(newData){
            // console.log('newData')
            // console.log(newData)
            if (newData && Object.keys(newData).length > 0) {
                // console.log('masuk')
                this.dataNotes = this.dataNotes.concat(newData.data);
                this.totalNotes = parseInt(newData.total_data);
                this.limitNotes = parseInt(newData.per_page);
                this.pageNotes = parseInt(newData.current_page);
                this.totalPageNotes = parseInt(newData.total_page);
            } else {
                this.setDefaulDataNotes()
                // console.log('else')
                // this.dataNotes = [];
                // this.totalNotes = 0;
                // this.limitNotes = 10;
                // this.pageNotes=0;
                // this.totalPageNotes=1;
            }
            this.isLoadingNext=false
        },
    },
}
</script>

<style lang="sass">
</style>
